import { Divider } from "pepsico-ds";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ButtonGroupDynamic from "../../../../common/ButtonGroupDynamic";

/**
 * Read-only summary of a configured retailer condition, rendered under the outcome
 * once retailers have been selected. Reads straight from the persisted `keywords`.
 */
export default function RetailerConditionDisplay({
  ruleData,
  onEdit,
  onDelete,
  readOnly,
}) {
  const { t } = useTranslation("RetailerOutcome");
  const retailers = ruleData?.keywords || [];

  if (retailers.length === 0) {
    return null;
  }

  const summary = t("RetailerSummary", { count: retailers.length });
  const retailerList = retailers.join(", ");

  return (
    <div
      className="store-condition-display"
      data-testid="retailer-condition-display"
    >
      <Divider
        style={{ margin: "16px 0", backgroundColor: "rgba(0, 92, 188, 0.2)" }}
      />
      <div className="store-condition-display__header">
        <div className="store-condition-display__header-left">
          <span className="store-condition-display__name">{retailerList}</span>
          <span className="store-condition-display__badge">
            {t("RetailerBadge")}
          </span>
        </div>
        {!readOnly && (
          <ButtonGroupDynamic
            size="small"
            items={[
              { icon: "edit", onClick: onEdit },
              { icon: "delete", onClick: onDelete },
            ]}
          />
        )}
      </div>
      <div className="store-condition-display__meta">
        <span className="store-condition-display__arrow">↳</span>
        <span>{summary}</span>
      </div>
    </div>
  );
}

RetailerConditionDisplay.propTypes = {
  ruleData: PropTypes.shape({
    keywords: PropTypes.arrayOf(PropTypes.string),
  }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  readOnly: PropTypes.bool,
};

RetailerConditionDisplay.defaultProps = {
  ruleData: null,
  readOnly: false,
};
